<template>
  <div class="panic-alert">
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PanicAlert'
}
</script>
